import { MouseEvent } from 'react'
import { useOverlay } from '../../contexts'
import { Container } from './Overlay.style'

export const Overlay = () => {
  const { isOpen, body, handleClose } = useOverlay()

  const close = (event: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => {
    if (event.target === event.currentTarget) {
      handleClose()
    }
  }

  return (
    <Container onClick={event => close(event)} isOpen={isOpen}>
      {body}
    </Container>
  )
}
